import { IGuid } from './ITypes';

export interface ISynchronization {
    Synchronizations: number;
    SynchronizationsLastYear: number;
    SynchronizationsThisYear: number;
    SynchronizationsLastMonth: number;
    SynchronizationsThisMonth: number;
}

export interface IAuthentications {
    Authentications: number;
    AuthenticationsLastYear: number;
    AuthenticationsThisYear: number;
    AuthenticationsLastMonth: number;
    AuthenticationsThisMonth: number;
}

export interface IPublishes {
    Publishes: number;
    PublishesLastYear: number;
    PublishesThisYear: number;
    PublishesLastMonth: number;
    PublishesThisMonth: number;
}
export interface IReports {
	Reports: number;
	ReportsLastYear: number;
	ReportsThisYear: number;
	ReportsLastMonth: number;
	ReportsThisMonth: number;
}

export interface ISyncByOrganizations extends ISynchronization, IAuthentications, IPublishes, IReports {
    ConnectedOn: string;
    ActiveOn: string;
    UsersLastMonth: number;
    UsersThisMonth: number;
}

export interface ISyncByUsers extends ISynchronization, IAuthentications, IReports {
    UserId: IGuid;
    ConnectedOn: string;
    ActiveOn: string;
}

export interface ISyncByDevices extends ISynchronization, IAuthentications {
    UserId: IGuid;
    DeviceId: IGuid;
    OS: string;
    Edition: string;
    Version: string;
    ConnectedOn: string;
    ActiveOn: string;
}

export const DefaultSyncByOrganizations : ISyncByOrganizations = {
    ConnectedOn: '',
    ActiveOn: '',
    UsersLastMonth: 0,
    UsersThisMonth: 0,
    Synchronizations: 0,
    SynchronizationsLastYear: 0,
    SynchronizationsThisYear: 0,
    SynchronizationsLastMonth: 0,
    SynchronizationsThisMonth: 0,
    Authentications: 0,
    AuthenticationsLastYear: 0,
    AuthenticationsThisYear: 0,
    AuthenticationsLastMonth: 0,
    AuthenticationsThisMonth: 0,
    Publishes: 0,
    PublishesLastYear: 0,
    PublishesThisYear: 0,
    PublishesLastMonth: 0,
	PublishesThisMonth: 0,
	Reports: 0,
	ReportsLastYear: 0,
	ReportsThisYear: 0,
	ReportsLastMonth: 0,
	ReportsThisMonth: 0
}